import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useConnections } from '@shared/hooks';
import ShopifyConnectionSetup from '@features/connections/shopify/components/ShopifyConnectionSetup';
import AmazonConnectionSetup from '@features/connections/amazon/components/AmazonConnectionSetup';

/** Setup after connect. Shopify and Amazon each map a marketplace field onto a Juststock field. */
const ConnectionSetup = () => {
  const { id } = useParams<{ id: string }>();
  const { connections } = useConnections();
  const connection = connections?.find((item) => item.id === id);

  if (!connections) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (connection?.connector.type === 'amazon') return <AmazonConnectionSetup />;
  return <ShopifyConnectionSetup />;
};

export default ConnectionSetup;
